function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import UploadFile from "../UploadFile";
import DeleteIcon from "../Icon/Delete";
import Tooltip from "../Tooltip/Tooltip";
import InfoIcon from "../Icon/Info";
import DownloadIcon from "../Icon/Download";
import { isCancellationError } from "../Dialog";
import { tokenStorage, formatDate } from '@atheneum/api/dist/lib';
import find from 'lodash/find';

class Attachment extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "downloadAttachment", (e, attachment) => {
      e.preventDefault();
      const iframe = document.querySelector('iframe#download-iframe');
      const formTemplate = '<form method="POST" action="/api/file/' + attachment.path + '"><input type="hidden" name="token" value="' + localStorage.getItem('ngStorage-accessToken') + '" /></form>';
      const tmp = document.createElement('div');
      tmp.innerHTML = formTemplate;
      /**
       * @type {HTMLFormElement}
       */
      // @ts-ignore

      const form = tmp.firstChild;
      tmp.innerHTML = '';
      iframe.appendChild(form);
      form.submit();
    });

    _defineProperty(this, "handleDelete", async attachmentId => {
      const {
        onDelete,
        growlStore
      } = this.props;

      try {
        await onDelete(attachmentId);
      } catch (err) {
        if (isCancellationError(err)) return;
        growlStore.showError(err);
      }
    });

    _defineProperty(this, "renderAttachments", () => {
      const {
        attachments
      } = this.props;
      if (!attachments || attachments.length < 1) return /*#__PURE__*/React.createElement("p", null, "No attachments...");
      return attachments.map(attachment => {
        const openableTypes = ['image/bmp', 'image/gif', 'image/jpeg', 'application/pdf', 'image/png', 'text/plain'];
        const employee = find(this.props.employeeStore.employees, {
          value: attachment.userId
        });

        if (openableTypes.includes(attachment.type)) {
          return this.renderFileOpenerLink({ ...attachment,
            path: encodeURIComponent(attachment.path),
            employee: employee.label
          });
        }

        return this.renderDownloadLink({ ...attachment,
          path: encodeURIComponent(attachment.path),
          employee: employee.label
        });
      });
    });

    _defineProperty(this, "renderDownloadLink", attachment => {
      return /*#__PURE__*/React.createElement("span", {
        key: attachment.id
      }, /*#__PURE__*/React.createElement("a", {
        href: "",
        onClick: e => this.downloadAttachment(e, attachment)
      }, attachment.name), /*#__PURE__*/React.createElement("div", {
        className: "delete-icon",
        onClick: () => this.handleDelete(attachment.id)
      }, !this.props.readOnly && /*#__PURE__*/React.createElement(DeleteIcon, null)), /*#__PURE__*/React.createElement("div", {
        className: "uploaded-by"
      }, "uploaded by ", attachment.employee, " on ", formatDate(attachment.updated_at)));
    });

    _defineProperty(this, "renderFileOpenerLink", attachment => {
      return /*#__PURE__*/React.createElement("span", {
        key: attachment.id
      }, /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        href: '/api/file/' + attachment.path + '?token=' + tokenStorage.get(),
        rel: "noreferrer"
      }, attachment.name), /*#__PURE__*/React.createElement("a", {
        href: "",
        className: "delete-icon",
        onClick: e => this.downloadAttachment(e, attachment)
      }, /*#__PURE__*/React.createElement(DownloadIcon, null)), /*#__PURE__*/React.createElement("div", {
        className: "delete-icon",
        onClick: () => this.handleDelete(attachment.id)
      }, !this.props.readOnly && /*#__PURE__*/React.createElement(DeleteIcon, null)), /*#__PURE__*/React.createElement("div", {
        className: "uploaded-by"
      }, "uploaded by ", attachment.employee, " on ", formatDate(attachment.updated_at)));
    });

    _defineProperty(this, "renderTooltip", () => {
      if (!this.props.tooltip) return null;
      return /*#__PURE__*/React.createElement(Tooltip, {
        tooltip: this.props.tooltip,
        placement: "top"
      }, /*#__PURE__*/React.createElement("div", {
        className: "iconWrapper"
      }, /*#__PURE__*/React.createElement(InfoIcon, null)));
    });
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "story attachment-container"
    }, /*#__PURE__*/React.createElement("span", {
      className: "label"
    }, this.props.label || 'Attachment', this.renderTooltip()), /*#__PURE__*/React.createElement("div", {
      className: "attachment-wrapper"
    }, this.renderAttachments()), !this.props.readOnly && /*#__PURE__*/React.createElement(UploadFile, {
      label: this.props.labelButton || 'Add attachment',
      url: this.props.url,
      onOk: this.props.onOk,
      preUpload: this.props.preUpload
    }));
  }

}

_defineProperty(Attachment, "propTypes", {
  url: PropTypes.string,
  onOk: PropTypes.func,
  onDelete: PropTypes.func,
  readOnly: PropTypes.bool,
  attachments: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  label: PropTypes.string,
  labelButton: PropTypes.string,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  growlStore: PropTypes.object,
  employeeStore: PropTypes.object
});

export default inject('userStore', 'growlStore', 'employeeStore')(observer(Attachment));